module.exports = __webpack_public_path__ + "static/media/icon_invalid.688ea07a.svg";